import { render, staticRenderFns } from "./KpiCardWidget.vue?vue&type=template&id=fcc47450&scoped=true"
import script from "./KpiCardWidget.vue?vue&type=script&lang=js"
export * from "./KpiCardWidget.vue?vue&type=script&lang=js"
import style0 from "./KpiCardWidget.vue?vue&type=style&index=0&id=fcc47450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc47450",
  null
  
)

export default component.exports